import "./styles.scss";

(function () {
  var header = document.getElementById('masthead');
  var lastScrollY = window.scrollY;
  var threshold = 5;
  var menuOpen = false;

  // Kompenzuj visinu headera da sadržaj ne skoči kad postane fixed
  function initSticky() {
    var h = header.offsetHeight;
    header.classList.add('js-sticky');
    // add root variable to css for header height
    document.documentElement.style.setProperty('--header-height', h + 'px');

    //document.body.style.paddingTop = h + 'px';
  }

  // Ažuriraj padding ako se visina headera promeni (npr. resize)
  window.addEventListener('resize', function () {
    //document.body.style.paddingTop = header.offsetHeight + 'px';
  });

  initSticky();

  // Meni toggle
  var menuToggle = document.querySelector('.menu-toggle, .nav-toggle, [aria-controls="primary-menu"]');
  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      menuOpen = !menuOpen;
      if (menuOpen) {
        header.classList.remove('hide');
      } else {
        lastScrollY = window.scrollY;
      }
    });
  }

  window.addEventListener('scroll', function () {
    if (menuOpen) return;
    var hh = header.offsetHeight;

    var currentScrollY = window.scrollY;
    if (Math.abs(currentScrollY - lastScrollY) < threshold) return;

    if (currentScrollY > hh) {
      header.classList.add('bg-white');
    } else {
      header.classList.remove('bg-white');
    }

    if (currentScrollY > lastScrollY) {
      header.classList.add('hide');
    } else {
      header.classList.remove('hide');
    }

    lastScrollY = currentScrollY;
  }, { passive: true });
})();

